import { FeatureCategory } from '../types';

export const chatCompanionsFeatures: FeatureCategory = {
  name: "Chat Companions & Support",
  icon: "Bot",
  features: [
    {
      name: "Chat Companions",
      description: "Access to all SeniorThrive chat companions: Avery (platform guide), Clarity (home safety), Riley (relationships & care), Luigi (cooking & nutrition), Finn (feline companion), and Charlie (canine buddy). Free plan includes 5 chats per week; Essential and above get unlimited.",
      starter: "5/week", max: "Unlimited", family: "Unlimited", careAddOn: "Unlimited"
    },
    { 
      name: "Web & Mobile App Access", 
      description: "SeniorThrive is a progressive web app, install it to your home screen like a regular app on any phone, tablet, or computer. No app store required. All data stays in sync.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    },
    { 
      name: "Live Agent Support", 
      description: "Access to live human support agents for technical assistance, platform guidance, and general help when needed.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    }
  ]
};
